import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "./nav_bar/Navbar";
import HeroSection from "./hero_section/HeroSection";
import FeaturesSection from "./FeaturesSection";
import HowDoesItWork from "./HowDoesItWork";
import GettingStarted from "./GettingStarted";
import TimeTable from "./time_table/TimeTable";
import CookieBanner from "./CookieBanner";
import Footer from "./footer/Footer";
import TestimonialsSection from "./TestimonialsSection";
import AnnouncementBar from "../announcement/AnnouncementBar";
import WordOfDayBanner from "./home/WordOfDayBanner";

const Homepage = () => {
  const location = useLocation();

  useEffect(() => {
    // If navigated from another page with scrollToHowItWorks flag
    if (location.state?.scrollToHowItWorks) {
      const section = document.getElementById("how-it-works");
      if (section) {
        // scroll smoothly to HowDoesItWork section
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
       <AnnouncementBar />
      <WordOfDayBanner />
      <HeroSection />
      <TimeTable />
      <FeaturesSection />
      {/*<TestimonialsSection />*/}
      <CookieBanner />
      {/* <CombinedSection /> */}
      <HowDoesItWork />
      <GettingStarted />
      <Footer />
    </>
  );
};

export default Homepage;
